import React, { useEffect, useState } from "react";
import "../Styles/SalarySlip.css";
import config from "../../config";
import { toWords } from "number-to-words";
import jsPDF from "jspdf";
import "jspdf-autotable";

const SalarySlipPopup = ({ onClose, staffId }) => {
    const [salarySlipData, setSalarySlipData] = useState(null);
    const [salarySlips, setSalarySlips] = useState([]);
    const [loading, setLoading] = useState(true);
    const currentMonth = new Date().toLocaleString("default", {
        month: "long",
    });
    const currentYear = new Date().getFullYear();
    const [netPay, setNetPay] = useState();
    const [netPayableAmount, setNetPayableAmount] = useState(null);
    const [advance, setAdvance] = useState(null);
    const [currentAdvance, setCurrentAdvance] = useState(null);
    const branchName = localStorage.getItem("branch_name");
    const sname = localStorage.getItem("s-name");

    const fetchEmployeeDataById = async (staffId) => {
        const token = localStorage.getItem("token");
        const bid = localStorage.getItem("branch_id");
        try {
            const response = await fetch(
                `${config.apiUrl}/api/swalook/staff/?id=${staffId}&branch_name=${bid}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error("Failed to fetch employee data");
            }
        } catch (error) {
            console.error("Error fetching employee data:", error);
        }
    };
    const bid = localStorage.getItem("branch_id");
    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchSalarySlip = async () => {
            setLoading(true);
            if (staffId) {
                try {
                    const response = await fetch(
                        `${config.apiUrl}/api/swalook/staff/?branch_name=${bid}`,
                        {
                            headers: {
                                Authorization: `Token ${token}`,
                                "Content-Type": "application/json",
                            },
                        }
                    );

                    const data = await response.json();

                    if (
                        data.status &&
                        data.table_data &&
                        Array.isArray(data.table_data)
                    ) {
                        const matchedEmployee = data.table_data.find(
                            (employee) => employee.staff_data.id === staffId
                        );
                        const advanceSaliry = data.table_data.find(
                            (employee) => employee.staff_data.id === staffId
                        );
                        if (advanceSaliry) {
                            setAdvance(advanceSaliry.advances);
                            setCurrentAdvance(
                                advanceSaliry.current_month_total
                            );
                        }
                        if (matchedEmployee) {
                            setSalarySlipData(matchedEmployee.staff_data);

                            const initialSlips =
                                matchedEmployee.salarySlips?.map((slip) => ({
                                    id: slip.id,
                                    month: slip.month,
                                    year: slip.year,
                                    downloadLink: slip.downloadLink,
                                })) || [];
                            setSalarySlips(initialSlips);

                            const payLoad = await fetch(
                                `${config.apiUrl}/api/swalook/staff/generate-payslip/?branch_name=${bid}&id=${staffId}`,
                                {
                                    headers: {
                                        Authorization: `Token ${token}`,
                                        "Content-Type": "application/json",
                                    },
                                }
                            );
                            const payLoadData = await payLoad.json();
                            setNetPay(payLoadData);
                            setNetPayableAmount(payLoadData.net_payble_amount);
                        } else {
                            setSalarySlipData(null);
                            setSalarySlips([]);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching salary slip:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchSalarySlip();
    }, [staffId]);

    const handleGenerateSalarySlip = () => {
        try {
            const newSlip = {
                id: salarySlips.length + 1,
                month: currentMonth,
                year: currentYear,
                downloadLink: "#",
            };
            setSalarySlips([...salarySlips, newSlip]);
        } catch (error) {
            console.error("Error generating salary slip:", error);
        }
    };

    const generatePDF = () => {
        const doc = new jsPDF();

        // Company Header
        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.text("Salary Slip", 105, 15, { align: "center" });

        doc.setFontSize(14);
        doc.setFont(undefined, "normal");
        doc.text(sname || " ", 105, 22, { align: "center" });

        // Employee Information Section
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        const startY = 35;

        doc.text(
            `Employee Name: ${salarySlipData?.staff_name || "N/A"}`,
            20,
            startY
        );
        doc.text(
            `Designation: ${salarySlipData?.staff_role || "N/A"}`,
            120,
            startY
        );

        doc.text(
            `Date of Joining: ${salarySlipData?.staff_joining_date || "N/A"}`,
            20,
            startY + 7
        );
        doc.text(
            `Payslip Period: ${currentMonth} ${currentYear}`,
            120,
            startY + 7
        );

        doc.text(
            `Worked Days: ${netPay?.no_of_working_days || 0}`,
            20,
            startY + 14
        );

        // Earnings Table
        let earnings = [
            ["Basic", `Rs. ${salarySlipData?.staff_salary_monthly || 0}`],
            ["Advance Paid", `Rs. ${currentAdvance || 0}`],
        ];

        if (salarySlipData?.staff_commision_cap > 0) {
            earnings.push([
                "Commission",
                `Rs. ${salarySlipData.staff_commision_cap}`,
            ]);
        }
        if (salarySlipData?.house_rent_allownance > 0) {
            earnings.push([
                "House Rent Allowance",
                `Rs. ${salarySlipData.house_rent_allownance}`,
            ]);
        }
        if (salarySlipData?.meal_allowance > 0) {
            earnings.push([
                "Meal Allowance",
                `Rs. ${salarySlipData.meal_allowance}`,
            ]);
        }

        earnings.push(["Total Earnings", `Rs. ${netPay?.earning || 0}`]);

        doc.autoTable({
            startY: startY + 25,
            head: [["Earnings", "Amount"]],
            body: earnings,
            theme: "grid",
            styles: { fontSize: 11, halign: "center", valign: "middle" }, // ✅ middle aligned
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                halign: "center",
                valign: "middle",
            },
            bodyStyles: { halign: "center", valign: "middle" },
        });

        // Deductions Table
        let deductions = [];
        if (salarySlipData?.staff_provident_fund > 0) {
            deductions.push([
                "Provident Fund",
                `Rs. ${salarySlipData.staff_provident_fund}`,
            ]);
        }
        if (salarySlipData?.staff_professional_tax > 0) {
            deductions.push([
                "Professional Tax",
                `Rs. ${salarySlipData.staff_professional_tax}`,
            ]);
        }
        if (salarySlipData?.totalDeductions > 0) {
            deductions.push([
                "Total Deductions",
                `Rs. ${salarySlipData.totalDeductions}`,
            ]);
        }

        if (deductions.length > 0) {
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [["Deductions", "Amount"]],
                body: deductions,
                theme: "grid",
                styles: { fontSize: 11, halign: "center", valign: "middle" }, // ✅ middle aligned
                headStyles: {
                    fillColor: [192, 57, 43],
                    textColor: 255,
                    halign: "center",
                    valign: "middle",
                },
                bodyStyles: { halign: "center", valign: "middle" },
            });
        }

        // Net Pay Section
        const netPayAmount =
            (netPay?.net_payble_amount || 0) - (currentAdvance || 0);
        const netPayY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 120;

        doc.setFontSize(13);
        doc.setFont(undefined, "bold");
        doc.text(`Net Pay: Rs. ${netPayAmount || 0}`, 190, netPayY, {
            align: "right",
        });

        // Net Pay in Words
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        let netPayWords = toWords(Math.floor(netPayAmount));
        if (netPayAmount % 1 > 0) {
            netPayWords += ` and ${toWords(
                Math.round((netPayAmount % 1) * 100)
            )} Cents`;
        }
        doc.text(`Net Pay in Words: ${netPayWords}`, 20, netPayY + 10);

        // Footer Disclaimer
        doc.setFontSize(9);
        doc.setTextColor(120, 120, 120);
        doc.text(
            "This is a system-generated document. No signature required.",
            105,
            doc.internal.pageSize.height - 10,
            { align: "center" }
        );

        // Save PDF
        doc.save(
            `Salary_Slip_${salarySlipData?.staff_name}_${currentMonth}_${currentYear}.pdf`
        );
    };

    const handleDownloadSlip = async (id) => {
        const slip = salarySlips.find((s) => s.id === id);
        if (slip) {
            const employeeData = await fetchEmployeeDataById(staffId);
            if (employeeData) {
                generatePDF();
                setSalarySlips((prevSlips) =>
                    prevSlips.map((s) =>
                        s.id === id ? { ...s, downloadLink: true } : s
                    )
                );
            } else {
                alert("Employee data not found.");
            }
        }
    };

    const employeeData = salarySlipData || {};

    return (
        <div className="popup-overlay2">
            <div className="popup-container2">
                <h2 className="popup-title2">Salary Slips</h2>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <>
                        {salarySlipData ? (
                            <>
                                <table className="salary-table2">
                                    <thead>
                                        <tr>
                                            <th>Month & Year</th>
                                            <th>Salary Slip</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salarySlips.map((slip) => (
                                            <tr key={slip.id}>
                                                <td>{`${slip.month} ${slip.year}`}</td>
                                                <td>
                                                    {slip.downloadLink ? (
                                                        <button
                                                            onClick={
                                                                generatePDF
                                                            }
                                                        >
                                                            Download PDF
                                                        </button>
                                                    ) : (
                                                        <button
                                                            onClick={() =>
                                                                handleDownloadSlip(
                                                                    slip.id
                                                                )
                                                            }
                                                        >
                                                            Generate PDF
                                                        </button>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full border border-gray-200 rounded-lg overflow-hidden">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-black uppercase tracking-wider border-b border-gray-200">
                                                    Advance Amount
                                                </th>
                                                <th className="px-6 py-3 text-left text-xs font-semibold text-black uppercase tracking-wider border-b border-gray-200">
                                                    Date
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">
                                            {advance?.length > 0 ? (
                                                advance.map((item, index) => (
                                                    <tr
                                                        key={index}
                                                        className="hover:bg-gray-50"
                                                    >
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-black">
                                                            {
                                                                item.advance_amount
                                                            }
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-sm text-black">
                                                            {item.created_at}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="2"
                                                        className="px-6 py-4 text-center text-sm text-gray-500"
                                                    >
                                                        No advances found
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                <button
                                    className="generate-button2"
                                    onClick={handleGenerateSalarySlip}
                                >
                                    Generate Salary Slip
                                </button>
                            </>
                        ) : (
                            <p>No salary slips available for this employee.</p>
                        )}
                    </>
                )}
                <button className="close-button2" onClick={onClose}>
                    Close
                </button>
            </div>
        </div>
    );
};

export default SalarySlipPopup;
